import React, { useState } from "react";
import PropTypes from "prop-types";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from "@material-ui/core/Icon";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import {
  activeRoute,
  activeSubItemRoute,
  checkRoutePermission,
  getParentSidebarUrl,
} from "utils";
import { useSidebar } from "components/Sidebar/SidebarContext";

const CollapsibleListItem = (props) => {
  const { t } = useTranslation();
  const { prop, classes, color } = props;
  const { openCollapsible, setOpenCollapsible } = useSidebar();

  const [open, setOpen] = useState(
    getParentSidebarUrl(location.pathname) === prop.path ||
      openCollapsible.includes(prop.path)
  );

  // If the sub-route has permission, then we have to show the collapsible
  const show = !!prop.items.filter((item) => {
    return checkRoutePermission([item.module, prop.module]);
  }).length;

  // This part of code keeps sidebar open boolean in context so that...
  // ...expanded sidebars behave the same even if sidebar is reloaded
  const handleClick = () => {
    if (!open) {
      let tempArray = openCollapsible;
      tempArray = [prop.path];
      if (
        typeof tempArray === "object" &&
        !openCollapsible.includes(prop.path)
      ) {
        setOpenCollapsible(tempArray);
      }
    } else {
      let itemIndex = openCollapsible.indexOf(prop.path);
      if (itemIndex !== -1) {
        let tempArray = openCollapsible;
        for (let i = 0; i < tempArray.length; ++i) {
          if (tempArray[i] === prop.path) {
            tempArray.splice(itemIndex, 1);
          }
        }
        if (
          typeof tempArray === "object" &&
          !openCollapsible.includes(prop.path)
        ) {
          setOpenCollapsible(tempArray);
        }
      }
    }
    setOpen(!open);
  };

  let listItemClasses = classNames({
    [" " + classes[color]]: activeRoute(prop.path),
  });

  if (open && !openCollapsible.includes(prop.path)) {
    if (!openCollapsible.length) {
      setOpenCollapsible([prop.path]);
    } else {
      setOpen(!open);
    }
  }

  // If none of the sub-route have permission, then there's no need
  // to show anything from this file in sidebar at all
  if (!show) return null;

  return (
    <>
      <ListItem
        button
        className={
          classes.itemLink + listItemClasses + " " + classes.sidebarHover
        }
        onClick={handleClick}
      >
        {typeof prop.icon === "string" ? (
          <Icon className={classes.itemIcon}>{prop.icon}</Icon>
        ) : (
          <FontAwesomeIcon
            fixedWidth
            icon={prop.icon}
            className={classes.itemIcon}
          />
        )}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <ListItemText
            className={classes.item}
            primary={t(prop.name)}
            disableTypography={true}
          />
          {open ? (
            <ExpandLess className={classes.item} />
          ) : (
            <ExpandMore className={classes.item} />
          )}
        </div>
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {prop.items.map((item, key) => {
            let subListItemClasses = classNames({
              [" " + classes[color]]: item.subItems
                ? activeSubItemRoute(prop.path + item.path)
                : activeRoute(prop.path + item.path),
            });
            let hasPermission = checkRoutePermission([
              item.module,
              prop.module,
            ]);
            if (!hasPermission) return null;
            let subItemUrl = "";
            if (item.subItems && item.subItems.length) {
              subItemUrl = "";
              item.subItems.forEach((subItem) => {
                if (!subItem.noTab && subItemUrl === "") {
                  subItemUrl = subItem.path;
                }
              });
            } else {
              return null;
            }
            return (
              <NavLink
                to={prop.path + item.path + subItemUrl}
                className={classes.item}
                activeClassName="active"
                key={key}
              >
                <ListItem
                  key={key}
                  button
                  className={
                    classes.nested +
                    subListItemClasses +
                    " " +
                    classes.sidebarHover
                  }
                >
                  <ListItemIcon className={classes.iconItem}>
                    <FontAwesomeIcon
                      fixedWidth
                      icon={item.icon}
                      className={classes.item}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={t(item.name)}
                    disableTypography={true}
                  />
                </ListItem>
              </NavLink>
            );
          })}
        </List>
      </Collapse>
    </>
  );
};

CollapsibleListItem.propTypes = {
  prop: PropTypes.object,
  classes: PropTypes.object,
  color: PropTypes.string,
};
export default CollapsibleListItem;
